import { render, staticRenderFns } from "./SnackBar.vue?vue&type=template&id=bd05654e&scoped=true&"
import script from "./SnackBar.vue?vue&type=script&lang=js&"
export * from "./SnackBar.vue?vue&type=script&lang=js&"
import style0 from "./SnackBar.vue?vue&type=style&index=0&id=bd05654e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd05654e",
  null
  
)

export default component.exports